/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["*[_ngcontent-%COMP%]{box-sizing:border-box;outline:0}.comingsoon[_ngcontent-%COMP%]   .comingsoon-imgwrap[_ngcontent-%COMP%]{margin:0 0 10px;display:flex;justify-content:center}.comingsoon[_ngcontent-%COMP%]   .comingsoon-imgwrap[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:100%}"];
export { styles as styles };
